import { useState, useRef, type KeyboardEvent } from 'react';
import styles from './InputBar.module.css';

interface InputBarProps {
  onSend: (message: string, files?: File[]) => void;
  teachMode: boolean;
  onToggleTeachMode: () => void;
  disabled?: boolean;
}

export function InputBar({ onSend, teachMode, onToggleTeachMode, disabled }: InputBarProps) {
  const [text, setText] = useState('');
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleSend = () => {
    if (!text.trim() || disabled) return;
    onSend(text);
    setText('');
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      onSend(text || `Uploaded ${files.length} file(s)`, Array.from(files));
      setText('');
      e.target.value = '';
    }
  };

  return (
    <div className={styles.inputBar}>
      {teachMode && (
        <div className={styles.teachBanner}>
          Teach Mode: ON — Everything you say will be captured as KBW knowledge.
        </div>
      )}
      <div className={styles.inputRow}>
        <button
          className={styles.attachBtn}
          onClick={() => fileInputRef.current?.click()}
          title="Attach file"
        >
          &#x1F4CE;
        </button>
        <input
          ref={fileInputRef}
          type="file"
          className={styles.fileInput}
          onChange={handleFileChange}
          accept=".xml,.dxf,.jpg,.jpeg,.png,.heic,.csv,.xlsx,.pdf,.docx"
          multiple
        />
        <input
          className={styles.textInput}
          placeholder="Holler at Foreman..."
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
        />
        <button
          className={`${styles.teachBtn} ${teachMode ? styles.teachActive : ''}`}
          onClick={onToggleTeachMode}
          title="Toggle Teach Mode"
        >
          &#x1F393;
        </button>
        <button
          className={`${styles.sendBtn} ${text.trim() ? styles.sendActive : ''}`}
          onClick={handleSend}
          disabled={!text.trim() || disabled}
        >
          Send
        </button>
      </div>
    </div>
  );
}
